import { render, staticRenderFns } from "./ProgressBars.vue?vue&type=template&id=6c622d8c&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c622d8c')) {
      api.createRecord('6c622d8c', component.options)
    } else {
      api.reload('6c622d8c', component.options)
    }
    module.hot.accept("./ProgressBars.vue?vue&type=template&id=6c622d8c&", function () {
      api.rerender('6c622d8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/basic-ui/ProgressBars.vue"
export default component.exports